// The settings that decide how a screen lays itself out.
//
// `GET /api/settings` returns EFFECTIVE values — each setting already resolved against
// its default — so a screen never has to know what the default was. That is a different
// read from `GET /api/admin/settings`, which is the console's and carries labels,
// descriptions and whether an admin has touched each one.
//
// FAILS TO THE DEFAULT, NEVER TO A BROKEN SCREEN. If the request fails, is aborted, or
// has simply not landed yet, this returns `{}` — and every consumer resolves `{}` to its
// own catalogue. So the worst outcome of a settings outage is that the Customers list
// looks the way it did before settings existed, which is a screen that works.
//
// That is also why there is no loading state exposed. A list that waited for this before
// rendering would flash empty on every navigation to save an arrangement most installs
// have not changed; rendering the default and then the arrangement is the same trade the
// rest of this app makes with `useLiveRefresh`.

import { useEffect, useState } from 'react';

import { api } from '../api/client.js';

export function useAppSettings() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const controller = new AbortController();
    api.get('/settings', { signal: controller.signal })
      .then((body) => setSettings(body?.data ?? {}))
      // Swallowed on purpose, including a real failure: there is nothing a screen can do
      // about it and nothing useful to tell an agent mid-call. The default renders.
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return settings;
}
